import React, { useState } from "react";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import "../firebase/firebase";

function Account({ user, setUser }) {
  const [productPrice, setProductPrice] = useState("");
  const [newUsername, setNewUsername] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const db = getFirestore();

  const handelShowPriceModal = () => {
    const modal = new window.bootstrap.Modal(
      document.getElementById("itemModal")
    );
    modal.show();
  };

  const handleSavePrice = async (e) => {
    e.preventDefault();
      setMessage("Product prices updated successfully.");

    try {
      const newPrice = parseFloat(productPrice); 
      if (isNaN(newPrice)) {
        setMessage("Please enter a valid price.");
        return;
      }

      const collections = [
        "collection1",
        "collection_1",
        "collection_2",
        "collection_3",
        "collection_4",
        "collection_5",
        "featureCollection",
        "kidsShirts",
        "menShirts",
        "womenShirts",
        "newArrivals",
      ];

      // Loop through all collections
      for (const collectionName of collections) {
        const productsRef = collection(db, collectionName);
        const querySnapshot = await getDocs(productsRef);

        // Loop through documents in each collection
        querySnapshot.forEach(async (doc) => {
          const productRef = doc.ref;

          // Update the productPrice field in each document
          await updateDoc(productRef, {
            productPrice: newPrice,
          });
        });
      }

    setMessage("");
      setProductPrice("");
    } catch (error) {
      console.error("Error updating prices: ", error);
      setMessage("Error updating prices.");
    }
  };

  const handleChangeUsername = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("username", "==", user.username));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        throw new Error("User not found");
      }

      const userDocRef = querySnapshot.docs[0].ref;
      const userData = querySnapshot.docs[0].data();

      if (userData.password !== currentPassword) {
        setMessage("Current password is incorrect.");
        return;
      }

      await updateDoc(userDocRef, {
        username: newUsername,
      });

      // Update user state and localStorage
      setUser({ username: newUsername });
      localStorage.setItem("user", JSON.stringify({ username: newUsername }));

      setNewUsername("");
      setCurrentPassword("");
      setNewPassword("");

      setMessage("Username updated successfully.");
    } catch (error) {
      console.error("Error updating username: ", error);
      setMessage("Error updating username.");
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("username", "==", user.username));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        throw new Error("User not found");
      }

      const userDocRef = querySnapshot.docs[0].ref;
      const userData = querySnapshot.docs[0].data();

      if (userData.password !== currentPassword) {
        setMessage("Current password is incorrect.");
        return;
      }

      await updateDoc(userDocRef, {
        password: newPassword,
      });

      setNewUsername("");
      setCurrentPassword("");
      setNewPassword("");

      setMessage("Password updated successfully.");
    } catch (error) {
      console.error("Error updating password: ", error);
      setMessage("Error updating password.");
    }
  };

  return (
    <div className="page-container">
      <h1 className="mt-3">Account</h1>
      {message && <div className="alert alert-info mt-3">{message}</div>}
      <div className="container mt-5">
        <div className="form-group">
          <label>Change Prices</label>
          <button
            className="btn btn-warning"
            type="button"
            onClick={handelShowPriceModal}
          >
            Change Prices
          </button>
        </div>

        <hr className="my-4" />

        <div className="form-group">
          <label>Current Username</label>
          <input
            type="text"
            className="form-control border-0"
            value={user.username}
            readOnly
            disabled
          />
        </div>
        <hr />
        <form onSubmit={handleChangeUsername} className="mt-3">
          <div className="form-group">
            <label htmlFor="newUsername">New Username</label>
            <input
              type="text"
              className="form-control"
              id="newUsername"
              placeholder="New Username"
              value={newUsername}
              onChange={(e) => setNewUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="currentPasswordForUsername">Current Password</label>
            <input
              type="password"
              className="form-control"
              id="currentPasswordForUsername"
              placeholder="Current Password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary mt-3">
            Change Username
          </button>
        </form>

        <form onSubmit={handleChangePassword} className="mt-5">
          <div className="form-group">
            <label htmlFor="currentPassword">Current Password</label>
            <input
              type="password"
              className="form-control"
              id="currentPassword"
              placeholder="Current Password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="newPassword">New Password</label>
            <input
              type="password"
              className="form-control"
              id="newPassword"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary mt-3">
            Change Password
          </button>
        </form>
        <hr className="my-4" />
        <button type="submit" className="btn btn-danger">
          Logout
        </button>
      </div>

      {/* Modal */}
      <div
        className="modal fade"
        id="itemModal"
        tabIndex="-1"
        aria-labelledby="itemModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="itemModalLabel">
                Change Prices
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <form onSubmit={handleSavePrice}>
              <div className="modal-body">
                <div className="form-group">
                  <label htmlFor="productPrice">Product Prices</label>
                  <input
                    type="number"
                    className="form-control"
                    id="productPrice"
                    placeholder="Product Price"
                    value={productPrice}
                    onChange={(e) => setProductPrice(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="submit"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  Save changes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Account;
